import { trim } from 'lodash';
import { createValueDefinitionKey } from '@common/i18n/createKey';
import { type InstallationInfo, type LocationData } from '@common/types/api';
import type DeviceShort from '@common/types/models/Device/DeviceShort';

export interface FullDeviceDataDifferentiator {
  readonly hasFullData: boolean;
}

export type DeviceAccessRequest =
  & Partial<DeviceShort>
  & Pick<DeviceShort, 'id' | 'deviceType' | 'name' | 'controllerUnit'>
  & { readonly location: LocationData; }
  & FullDeviceDataDifferentiator;

export const hasFullData = (
  v: FullDeviceDataDifferentiator,
): v is DeviceShort => v.hasFullData;

export const createDeviceAccessRequestFromResponse = (
  apiDevice: InstallationInfo,
): DeviceAccessRequest => {
  const imageName = apiDevice.deviceType?.replace(/\s/g, '-');
  return {
    hasFullData: false,
    id: apiDevice.id,
    iconPath: `/assets/external/device/icons/${imageName}-small.png`,
    deviceType: createValueDefinitionKey(apiDevice.deviceType),
    name: trim(apiDevice.name),
    controllerUnit: createValueDefinitionKey(apiDevice.controllerUnit),
    location: apiDevice.location,
  };
};
